'use strict';

angular.module('far.core')
    .controller('AppController', function (maps) {
        var ac = {
            menu_show: false,
            hideMenu: hideMenu,
            map: {
                options: {
                    disableDefaultUI: true,
                    zoomControl: true,
                    scrollwheel: false,
                    styles: maps.getStyle()
                }
            }
        };

        function hideMenu(event) {
            if (event.target.classList.contains('hamburger') || event.target.classList.contains('hamburger__ico')) {
                return;
            }

            if (ac.menu_show) {
                ac.menu_show = false;
            }
        }

        return ac;
    });
